<app-loader [isLoading]="isLoading"></app-loader>

@if(!isMobileView){
  <div class="modal-heading">
    <h2 class="modal-title">User Filter</h2>
    <div class="close-button" (click)="closeDialog()">
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>

  <div class="modal-container">  
    <form class="form-container">
      <div class="d-flex flex-column" style="gap: 20px">
        <div class="user-details-div d-flex flex-column gap-3">
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center" style="gap: 8px">
              <span class="user-status-text"> State </span>
            </div>
            <div class="custom-dropdown">
              <mat-form-field class="select-mat-form-field custom-select-form">
                <mat-select
                  class="custom-mat-select custom-select"
                  id="state"
                  placeholder="Select State"
                  [(value)]="selectedState"
                >
                  <mat-option *ngFor="let state of states; let i = index" [value]="state" (click)="displayDistrict(state)">
                    {{ state }}
                  </mat-option>
                </mat-select>
                <button mat-icon-button *ngIf="selectedState != ''" matSuffix (click)="clearStateSelection()"
                  class="clear-button">
                  <mat-icon class="clear-icon">clear</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center" style="gap: 8px">
              <span class="user-status-text"> District </span>
            </div>
            <div class="custom-dropdown">
              <mat-form-field class="select-mat-form-field custom-select-form">
                <mat-select
                  class="custom-mat-select custom-select"
                  id="district"
                  placeholder="Select District"
                  [(value)]="selectedDistrict"
                >
                  <mat-option *ngFor="let district of districts[selectedState]; let i = index" [value]="district">
                    {{ district }}
                  </mat-option>
                </mat-select>
                <button mat-icon-button *ngIf="selectedDistrict != ''" matSuffix (click)="clearDistrictSelection()"
                  class="clear-button">
                  <mat-icon class="clear-icon">clear</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center" style="gap: 8px">
              <span class="user-status-text"> Pincode </span>
            </div>
            <div class="custom-dropdown">
              <div class = "pincode-search-container">
                <input 
                  type="text" placeholder="Enter Pincode"
                  class="pincode-search-box dp-input-control display: flex; gap: 12px;"
                  [formControl]="pincodeFilterTerm" 
                />
                <button mat-icon-button *ngIf="pincode != ''" matSuffix (click)="clearPincodeSelection()"
                  class="clear-button">
                  <mat-icon class="clear-icon">clear</mat-icon>
                </button>
              </div>
            </div>
          </div>
          
        </div>


        <div class="user-details-div d-flex justify-content-between">
          <div class="d-flex align-items-center" style="gap: 8px">
            <span class="user-status-text"> Level </span>
          </div>
          <div class="custom-dropdown">
            <mat-form-field class="select-mat-form-field custom-select-form">
              <mat-select
                class="custom-mat-select custom-select"
                id="permissionLevel"
                placeholder="Permission Level"
                [(value)]="selectedLevel"
              >
                <mat-option *ngFor="let level of levels; let i = index" [value]="level">
                  {{ level }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

      </div>
    </form>
  
    <div class="btn-container d-flex justify-content-end">
      <button class="dp-secondary-btn btn-div" (click)="applyFilter()">
      Apply Filter
      </button>
    </div>
    
  </div>

}